import Vue from 'vue';
import { createInertiaApp } from '@inertiajs/vue2';
import vuetify from '@/lite/plugins/vuetify';
import PortalVue from 'portal-vue';

Vue.use(PortalVue);

window.eventBus = new Vue;

Vue.mixin({
  methods: {
    route: window.route,
  }
});

createInertiaApp({
  progress: {
    color: '#29d',
  },
  resolve: name => require(`./Pages/${name}`),
  setup({ el, App, props, plugin }) {
    Vue.use(plugin)

    new Vue({
      vuetify,
      render: h => h(App, props),
    }).$mount(el)
  },
})